var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ResolveTypeLink',{attrs:{"internal-link":_vm.internalLink,"href":_vm.getHref(),"value":_vm.value,"text-color":_vm.textColor,"text-size":_vm.textSize,"link-class-name":_vm.linkClassName,"pill":_vm.pill},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }